import React from 'react';
import {observer} from "mobx-react-lite";
import {MidiSupportWarning} from './components/midi/MidiSupportWarning';
import {Header} from "./components/Header";
import {Tabs} from "./components/Tabs";
// import {AllPresets} from "./components/AllPresets";
import {stores} from "./stores";
import {SinglePreset} from "./components/SinglePreset";
import {Help} from "./components/Help";
import {PresetsGrid} from "./components/PresetsGrid";
import './App.css';
import './components/Presets.css';
import {Utils} from "./components/Utils";

export const App = observer(() => {
    return (
        <>
            <MidiSupportWarning />
            <Header />
            <Tabs />
            {stores.state.activeTab === 'single' && <SinglePreset />}
            {stores.state.activeTab === 'all' && <PresetsGrid />}
            {stores.state.activeTab === 'utils' && <Utils />}
            {stores.state.activeTab === 'help' && <Help />}
        </>
    );
});
